import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import App from './App';
import { initAnalytics } from '@/lib/analytics';
import './styles/globals.css';

// Inicializa PostHog antes de renderizar para capturar el primer pageview.
// Blindado: en Safari con "Bloquear todas las cookies" / bloqueadores, el
// acceso a localStorage puede lanzar y romper el arranque. Analytics NUNCA
// debe impedir que la app monte.
try {
  initAnalytics();
} catch (e) {
  console.error('[analytics] init falló, continuando sin analytics:', e);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          // Opt-in temprano a comportamientos de React Router v7. Elimina
          // los warnings de "Future Flag" en console y nos prepara para
          // el upgrade futuro sin sorpresas.
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
